import React from "react";

const InvitedTalk = () => {
  return (
    <div className="textAlign">
     {/* *****Uncomment this for adding content in invited Talks***** */}
      {/* <b>
        <font color="black"> Singh JK, </font>
      </b>
      Insights into material behavior via molecular simulations, Invictus Oncology Pvt. Ltd. Delhi, October 24, 2018. */}
    </div>
  );
};

export default InvitedTalk;
